import { format } from "date-fns";
import { Timestamp } from "firebase/firestore";

const formatString = "d MMM yyyy, HH:mm";

const formatUpdatedAtMilliseconds = (milliseconds: number): string => {
  return format(new Date(milliseconds), formatString);
};

const formatUpdatedAtTimestamp = (date: Timestamp): string => {
  return format(date.toDate(), formatString);
};

const formatUpdatedAtDate = (date: Date): string => {
  return format(date, formatString);
};

export const formatUpdatedAt = (date: Date | Timestamp | number): string => {
  if (date instanceof Date) {
    return formatUpdatedAtDate(date);
  }
  if (typeof date === "number") {
    return formatUpdatedAtMilliseconds(date);
  }
  return formatUpdatedAtTimestamp(date);
}